module.exports = __webpack_public_path__ + "static/media/produtos.9f4b264d.xlsx";